import { fetchPictograms, fetchPictogram, assignStatusesToLayers as apiAssignStatusesToLayers,
  saveDataLayers as apiSaveLayers,
  saveStatusesLayers as apiStatusesLayers,
  getLinkedEntities as apiGetLinkedEntities,
  unlinkEntities as apiUnlinkEntities,
  assignEntities as apiAssignEntities,
  recalculateProgress as apiRecalculateProgress,
  getPictogramDesign as apiGetPictogramDesign,
  updatePictogramDesignGeoreferencing as apiUpdatePictogramDesignGeoreferencing,
  editPartialPictogram as apiEditPartialPictogram,
  previewVersionUpload as apiPreviewVersionUpload,
  confirmVersionUpload as apiConfirmVersionUpload,
  getPendingVersion as apiGetPendingVersion,
  discardPendingVersion as apiDiscardPendingVersion,
  getPendingVersionSceneUrl as apiGetPendingVersionSceneUrl,
  getPendingVersionDxfUrl as apiGetPendingVersionDxfUrl,
  getCurrentDxfUrl as apiGetCurrentDxfUrl,
  getCurrentSceneBinaryUrl as apiGetCurrentSceneBinaryUrl,
  registerLayerProgress as apiRegisterLayerProgress,
  getPictogramComponents as apiGetPictogramComponents,
  startRestoreFromVersion as apiStartRestoreFromVersion,
  deleteDocumentVersion as apiDeleteDocumentVersion,
  bulkApplyLayerConfig as apiBulkApplyLayerConfig,
 } from '../api/pictograms.api.js';

 import { configPictogramOptions } from '../data/config-pictogram-options.js';
 import { apiCall } from '../helpers/api.helper.js';

 export async function getPictogram(pictogramId, filters = {}) {
  try {
    const pictograms = await fetchPictogram(pictogramId, filters);
    return pictograms;
  } catch (e) {
    console.error("Error al obtener los pictogramas del proyecto", e);
    throw e;
  }
}

export async function getPictograms(projectId, filters = {}) {
  try {
    const pictograms = await fetchPictograms(projectId, filters);
    return pictograms;
  } catch (e) {
    console.error("Error al obtener los pictogramas del proyecto", e);
    throw e;
  }
}

export function getListItemsNavigation(pictogram) {
  if (!pictogram) {
    return configPictogramOptions;
  }

  // Mapear las opciones para agregar pictogram como props en cada componente
  return configPictogramOptions.map(option => {
    if (option.component && option.component.props) {
      return {
        ...option,
        component: {
          ...option.component,
          props: {
            ...option.component.props,
            projectId: pictogram.project_id,
            entity: pictogram,
            entityType: 'pictogram'
          }
        }
      };
    }
    return option;
  });
}

export async function getPictogramDesign(pictogramId) {
  try {
    const response = await apiGetPictogramDesign(pictogramId);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getPictogramDesignGeoreferencing(pictogramId) {
  try {
    const response = await apiGetPictogramDesign(pictogramId);
    const data = response.data;

    // Si, llega success=true hay pictogramDesigne retornamos los datos
    if (data.success) {
      return {
        metadata: {
          origin: data.pictogramDesign.metadata.origin,
          bounds: data.pictogramDesign.metadata.bounds,
          units: data.pictogramDesign.metadata.units,
          // layers: data.pictogramDesign.metadata.layers,
        },
        georeferencing: data.pictogramDesign.georeferencing
      };
    }
    // Si no, retornamos null
    return null;
  } catch (error) {
    throw error;
  }
}

export async function updatePictogramDesignGeoreferencing(pictogramId, payload) {
  try {
    const response = await apiUpdatePictogramDesignGeoreferencing(pictogramId, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const editPartialPictogram = (pictogramId, payload) => apiCall(apiEditPartialPictogram, pictogramId, payload);
export const assignStatusesToLayers = (data) => apiCall(apiAssignStatusesToLayers, data);
export const saveDataLayers = (payload) => apiCall(apiSaveLayers, payload);
export const saveStatusesLayers = (payload) => apiCall(apiStatusesLayers, payload);
export const getLinkedEntities = (pictogramId, params) => apiCall(apiGetLinkedEntities, pictogramId, params);
export const unlinkEntities = (pictogramId, payload) => apiCall(apiUnlinkEntities, pictogramId, payload);
export const assignEntities = (payload) => apiCall(apiAssignEntities, payload);
export const recalculateProgress = (pictogramId) => apiCall(apiRecalculateProgress, pictogramId);
export const previewVersionUpload = (pictogramId, payload) => apiCall(apiPreviewVersionUpload, pictogramId, payload);
export const confirmVersionUpload = (pictogramId, payload) => apiCall(apiConfirmVersionUpload, pictogramId, payload);
export const getPendingVersion = (pictogramId) => apiCall(apiGetPendingVersion, pictogramId);
export const discardPendingVersion = (pictogramId) => apiCall(apiDiscardPendingVersion, pictogramId);
export const getPendingVersionSceneUrl = (pictogramId) => apiCall(apiGetPendingVersionSceneUrl, pictogramId);
export const getPendingVersionDxfUrl = (pictogramId) => apiCall(apiGetPendingVersionDxfUrl, pictogramId);
export const getCurrentDxfUrl = (pictogramId) => apiCall(apiGetCurrentDxfUrl, pictogramId);
export const getCurrentSceneBinaryUrl = (pictogramId) => apiCall(apiGetCurrentSceneBinaryUrl, pictogramId);
export const registerLayerProgress = (pictogramId, layerId, payload) =>
  apiCall(apiRegisterLayerProgress, pictogramId, layerId, payload);
export const getPictogramComponents = (pictogramId) =>
  apiCall(apiGetPictogramComponents, pictogramId);
export const startRestoreFromVersion = (pictogramId, fromDocumentVersionId) => apiCall(apiStartRestoreFromVersion, pictogramId, fromDocumentVersionId);
export const deleteDocumentVersion = (pictogramId, documentVersionId) => apiCall(apiDeleteDocumentVersion, pictogramId, documentVersionId);
export const bulkApplyLayerConfig = (pictogramId, payload) => apiCall(apiBulkApplyLayerConfig, pictogramId, payload);
